import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62717e2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full flex flex-row md:flex-col sm:px-0 px-4 bg-red-0" }

import { ref, Ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnCategory',
  setup(__props) {

const activeMenu :Ref<String> = ref('expo') 
const handleBtn = (menu :string) => {
    // console.log(menu)
    activeMenu.value = menu;

}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/news/event" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'expo' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleBtn('expo')))
        }, "📍 박람회/이벤트", 2)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/news/column" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'column' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleBtn('column')))
        }, "📢 칼럼/뉴스", 2)
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, { to: "/news" }, {
      default: _withCtx(() => [
        _createElementVNode("h3", {
          class: _normalizeClass(["btn",  activeMenu.value === 'news' ? 'bg-[#f9f9f9] ' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleBtn('news')))
        }, "🕊 양서파충류 공식 채널", 2)
      ]),
      _: 1
    })
  ]))
}
}

})